import { z } from 'zod';
import phoneNumber from '../common/phoneNumber.dto';
import { namedReference } from '../common/reference.dto';
import {
  AreYouOkDtoStatus,
  AreYouOkUpdateDtoStatus,
} from '../generated/openapi/safety-check';
import { areYouOkPendingResponse } from './pending/pending.dto';

export const statusUpdate = z.enum(AreYouOkUpdateDtoStatus);
const status = z.enum(AreYouOkDtoStatus);

const areYouOkBase = z.object({
  id: z.string(),
  title: z.string().nullable(),
  description: z.string().optional(),
  ongoing: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date().optional(),
  phoneNumber: phoneNumber.optional(),
  locale: z.string(),
  organization: namedReference,
  pending: areYouOkPendingResponse.optional(),
});

const areYouOk = areYouOkBase.extend({
  status: status.optional(),
});

export const areYouOkUpdate = areYouOkBase.extend({
  status: statusUpdate,
});

export default areYouOk;

export type AreYouOk = z.infer<typeof areYouOk>;
export type AreYouOkStatusUpdate = z.infer<typeof statusUpdate>;
export const AreYouOkStatusUpdateEnum = statusUpdate.enum;
export type AreYouOkUpdate = z.infer<typeof areYouOkUpdate>;
export type AreYouOkStatus = z.infer<typeof status>;
export const AreYouOkDtoStatusEnum = status.enum;
